// Recovered compiled webpack factory 31439. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { B: () => a });
  var n = i(38708);
  let s = { offset: "stroke-dashoffset", array: "stroke-dasharray" },
    r = { offset: "strokeDashoffset", array: "strokeDasharray" },
    o = ["offsetDistance", "offsetPath", "offsetRotate", "offsetAnchor"];
  function a(
    t,
    {
      attrX: e,
      attrY: i,
      attrScale: a,
      pathLength: l,
      pathSpacing: h = 1,
      pathOffset: u = 0,
      ...d
    },
    c,
    p,
    m,
  ) {
    if (((0, n.O)(t, d, p), c)) {
      t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
      return;
    }
    ((t.attrs = t.style), (t.style = {}));
    let { attrs: f, style: v } = t;
    for (let t of (f.transform && ((v.transform = f.transform), delete f.transform),
    (v.transform || f.transformOrigin) &&
      ((v.transformOrigin = f.transformOrigin ?? "50% 50%"), delete f.transformOrigin),
    v.transform && ((v.transformBox = m?.transformBox ?? "fill-box"), delete f.transformBox),
    o))
      void 0 !== f[t] && ((v[t] = f[t]), delete f[t]);
    (void 0 !== e && (f.x = e),
      void 0 !== i && (f.y = i),
      void 0 !== a && (f.scale = a),
      void 0 !== l &&
        (function (t, e, i = 1, n = 0, o = !0) {
          t.pathLength = 1;
          let a = o ? s : r;
          ((t[a.offset] = `${-n}`), (t[a.array] = `${e} ${i}`));
        })(f, l, h, u, !1));
  }
}
